/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import Typography from '@ntuctech/devex-tangram/Typography'

import { SCREEN_SIZE } from '../../../lib/Media'

import Panel from '../Panel/Panel'
import Benefits from '../sections/Benefits'
import MembershipForm from '../sections/MembershipForm'

import LoginImg from '../../../static/Loyalty/login.png'
import LoginImg2x from '../../../static/Loyalty/login@2x.png'
import LoginImg3x from '../../../static/Loyalty/login@3x.png'

import {
  GTM_ENV_VAR as GEV,
  PAGE_TYPES,
} from '../../../lib/eventTrackerFunction'

const Header = styled.div`
  overflow: hidden;
  margin-bottom: 1rem;
  img {
    max-width: 50%;
    float: right;
    ${SCREEN_SIZE.From.Desktop} {
      max-width: none;
    }
  }
`

const Guest = ({ status, data, track }) => {
  const Router = useRouter()
  const viewForm = Router.query.login === 'true'

  function trackView() {
    track({
      [GEV.PAGE_TYPE]: PAGE_TYPES.JWC_HOMEPAGE,
      [GEV.SCREEN_NAME]: PAGE_TYPES.JWC_HOMEPAGE,
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: '01homepage_page',
      [GEV.EVENT_LABEL]: 'Loc=JWCHome',
      [GEV.ASSET_TYPE]: 'JWC',
      [GEV.JWC_REFERRER]: document.referrer,
    })
  }

  function trackLoginRegister() {
    track({
      [GEV.PAGE_TYPE]: PAGE_TYPES.JWC_HOMEPAGE,
      [GEV.SCREEN_NAME]: PAGE_TYPES.JWC_HOMEPAGE,
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: '01Homepage_Clickloginregister',
      [GEV.EVENT_LABEL]: 'Loc=JWCHome-LoginRegister',
      [GEV.ASSET_TYPE]: 'JWC',
      [GEV.JWC_REFERRER]: document.referrer,
    })
  }

  useEffect(() => {
    trackView()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (viewForm && status === 'user') {
    return (
      <Panel title="Apply for membership">
        <MembershipForm
          tncUrl={data && data.tncUrl}
          packages={data ? data.packages : []}
          track={track}
        />
      </Panel>
    )
  }

  return (
    <React.Fragment>
      <Panel shadow data-testid="loyalty-guest-panel">
        <Header>
          <img
            src={LoginImg}
            srcSet={`${LoginImg} 1x, ${LoginImg2x} 2x, ${LoginImg3x} 3x`}
            alt="Login"
          />
          <Typography variant="h3">Join as a member</Typography>
          <Typography variant="body2">
            <React.Fragment>
              {status === 'guest' && 'Log in with your FairPrice account!'}
              {status === 'user' && 'Sign up for Just Wine Club membership'}
            </React.Fragment>
          </Typography>
        </Header>
        {status === 'guest' && (
          <Link href={`/login?redirect=${Router.asPath}?login=true`} legacyBehavior>
            <ButtonContained
              data-testid="fp-login-button"
              size="l"
              onClick={trackLoginRegister}
              fullWidth
            >
              Login to FairPrice
            </ButtonContained>
          </Link>
        )}
        {status === 'user' && (
          <Link href={`?login=true`} legacyBehavior>
            <ButtonContained data-testid="sign-up-button" size="l" fullWidth>
              Sign up
            </ButtonContained>
          </Link>
        )}
      </Panel>
      {data?.benefits && (
        <Panel shadow>
          <Benefits content={data.benefits} />
        </Panel>
      )}
    </React.Fragment>
  );
}

export default Guest
